import { izireportVersion } from "@taskpane/types";
import React, { ReactNode } from "react";

interface FooterProps {
  children?: ReactNode;
}

export const Footer = ({ children }: FooterProps) => (
  <div className="bg-white">
    <hr></hr>
    {children}
    <div className="d-flex justify-content-center m-2">
      <span>
        Powered by
      </span>
      <span className="ms-2 me-2">
        <img src="assets/logoGit.png" />
      </span>
      <span className="ms-1">
        <span className="pl-2">v{izireportVersion}</span>
      </span>
    </div>
  </div>
);
